import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    title = 'say-design-system-app';

    constructor( private location: Location) {}

    ngOnInit() {}

    get currentLocation(): string {
        return this.location.path();
    }
}